var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-131.881 -271.881)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 108,
    height: 108,
    rx: 32,
    transform: "translate(131.881 271.881)",
    fill: "#fef2f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Evento_Icons",
    "data-name": "Evento Icons",
    transform: "translate(154.686 294.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H61.565V61.565H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548",
    transform: "translate(4.898 4.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M-6732.947-2762.922a26.324,26.324,0,0,1-26.311,26.275,26.326,26.326,0,0,1-26.3-26.406,26.323,26.323,0,0,1,26.374-26.21A26.318,26.318,0,0,1-6732.947-2762.922Zm-26.229-22.29A22.267,22.267,0,0,0-6781.511-2763a22.272,22.272,0,0,0,22.117,22.3A22.266,22.266,0,0,0-6737-2762.847,22.266,22.266,0,0,0-6759.176-2785.211Z",
    transform: "translate(6785.563 2789.263)",
    fill: "#ff295c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M-6757.479-2766.151c0-2.229-.012-4.459,0-6.688.011-1.482.794-2.378,2.028-2.375s2.012.908,2.016,2.387q.017,6.752,0,13.5a2.06,2.06,0,0,1-1.963,2.313c-1.226.036-2.067-.882-2.078-2.327C-6757.492-2761.608-6757.479-2763.88-6757.479-2766.151Z",
    transform: "translate(6781.761 2787.361)",
    fill: "#ff295c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M-6755.582-2743.406a3.054,3.054,0,0,1-3.062-3.035,3.054,3.054,0,0,1,3.066-3.031,3.051,3.051,0,0,1,3,2.971A3.051,3.051,0,0,1-6755.582-2743.406Z",
    transform: "translate(6781.918 2783.876)",
    fill: "#ff295c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentErrorIcon);
export default __webpack_public_path__ + "static/media/PaymentErrorIcon.252fabfc29e7784db71d0104a145610e.svg";
export { ForwardRef as ReactComponent };